import React from "react";
import { useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import { Link, useSearchParams } from "react-router-dom";
import { useUser } from "../../../hooks/use-user";
import { errorToast } from "../../../utils/toast";
import axios from "../../../axios";
import { FaArrowRightLong } from "react-icons/fa6";
import Correct from "../../../Images/Vector.png";
import bgImage from "../../../Images/Section (2).png";
import Info from "../../../Images/ph_info-duotone.png";
import Table from "../../../componant/Table/Table";
import Cell from "../../../componant/Table/cell";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
  ChevronDownIcon,
  Button,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
  useDisclosure,
  Box,
  FormControl,
  FormLabel,
  Text,
  InputGroup,
  InputLeftElement,
  Input,
  InputRightAddon,
  useToast,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Switch,
} from "@chakra-ui/react";

import { MdEdit, MdDelete } from "react-icons/md";
import { HiStatusOnline } from "react-icons/hi";
import { GrOverview } from "react-icons/gr";
import PaginationNav from "../../../componant/Pagination/Pagination";
import ContestCard from "./ContestCard";
import DeletePasswordModal from "../../../componant/DeletePasswordModal";

// -------------------------------------------
const getPageFromSearchParams = (searchParams) => {
  const page = Number(searchParams.get("page"));
  return Number.isInteger(page) && page > 0 ? page : 1;
};

function ViewContest() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();
  const {
    isOpen: isOpen3,
    onOpen: onOpen3,
    onClose: onClose3,
  } = useDisclosure();
  const btnRef = React.useRef();

  const cancelRef = React.useRef();
  const toast = useToast();
  const [data, setData] = useState([]);
  const [newID, setNewID] = useState(null);
  const [contestId, setContestid] = useState(null);
  const [totalJoined, setTotalJoined] = useState(0);
  const [showNoQuestionsWarning, setShowNoQuestionsWarning] = useState(false);
  const [totalContests, setTotalContests] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();


const [searchText, setSearchText] = useState("");
const [sortType, setSortType] = useState(""); // "price" | "date"
const [filterStatus, setFilterStatus] = useState(""); // "active" | "inactive"
const [page, setPage] = useState(() => getPageFromSearchParams(searchParams));
const [totalPages, setTotalPages] = useState(1);
const pageSize = 10;
const searchPageSize = 100000;

  // const [isOpen1, setIsOpen1] = useState(false);
  // const [isOpen2, setIsOpen2] = useState(false);

  // const toggleDropdown = () => {
  //   setIsOpen1(!isOpen1);
  // };
  // const toggleDropdown2 = () => {
  //   setIsOpen2(!isOpen2);
  // };

useEffect(() => {
  const nextPage = getPageFromSearchParams(searchParams);
  setPage((currentPage) => (currentPage === nextPage ? currentPage : nextPage));
}, [searchParams]);

useEffect(() => {
  const currentPage = getPageFromSearchParams(searchParams);
  if (currentPage === page) return;

  const nextSearchParams = new URLSearchParams(searchParams);
  if (page <= 1) {
    nextSearchParams.delete("page");
  } else {
    nextSearchParams.set("page", String(page));
  }

  setSearchParams(nextSearchParams, { replace: true });
}, [page, searchParams, setSearchParams]);


useEffect(() => {
  async function fetchData() {
    try {
      console.log(page,"page",pageSize,"pagesize")
      const isSearching = Boolean(searchText.trim());
      const params = new URLSearchParams({
        page: isSearching ? "1" : String(page),
        limit: String(isSearching ? searchPageSize : pageSize),
      });

      const response = await axios.get(
        `getAllContestForAdmin?${params.toString()}`
      );

      if (response?.data) {
        // Support both the old array response and the paginated response.
        const result = response.data.result;
        const contests = Array.isArray(result) ? result : result?.contests || [];
        setData(contests);
        setTotalPages(isSearching ? 1 : Array.isArray(result) ? 1 : result?.totalPages || 1);

        if (contests.length > 0) {
          setContestid(contests[0]._id);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  fetchData();
}, [page, searchText]);

  const refetchData = async () => {
    try {
      const isSearching = Boolean(searchText.trim());
      const params = new URLSearchParams({
        page: isSearching ? "1" : String(page),
        limit: String(isSearching ? searchPageSize : pageSize),
      });

      const response = await axios.get(
        `getAllContestForAdmin?${params.toString()}`
      );

      if (response?.data) {
        const result = response.data.result;
        const contests = Array.isArray(result) ? result : result?.contests || [];
        setData(contests);
        setTotalPages(isSearching ? 1 : Array.isArray(result) ? 1 : result?.totalPages || 1);
      }
    } catch (error) {
      console.log(error);
    }
  };

  
  const handleDelete = () => {
    axios
      .delete(`deleteContest/${newID}`)
      .then((res) => {
        if (res.data) {
          console.log(res.data);
          toast({
            title: `Success! This course has been deleted`,

            status: "success",
            duration: 4000,
            isClosable: true,
            position: "top",
          });
          refetchData();
        }
      })
      .catch((err) => {
        toast({
          title: `Something Went Wrong!`,

          status: "error",
          duration: 4000,
          isClosable: true,
        });
      });
  };

  const [formData, setTextData] = useState({
    contestName: "",
    contestNameHin: "",
    startTime: "",
    endTime: "",
    prizePoolCoin: "",
    duration: "",
    isActive: false,
    entryCoin: "",
    winners: "",
    totalSlot: "",
    winnerPrizes: "",
  });
  const [sendPushNotification, setSendPushNotification] = useState(false);

  useEffect(() => {
    if (!newID) return;
    const selectedContest = data.find((contest) => contest._id === newID);
    if (!selectedContest) return;

    const { _id, __v, createdOn, ...editableContest } = selectedContest;
    setTextData(editableContest);
    setSendPushNotification(false);
  }, [newID, data]);

  // useEffect(()=>{
  //   fetchJoinedData()
  // },[])
  // const fetchJoinedData = async () => {
  //   try {
  //     const response = await axios.get(`getTotalUserJoinedContestCount`);
  //     console.log(response.data)
  //     // return response?.data?.result?.totalUserJoinedCount || 0;
  //   } catch (error) {
  //     console.log(error);
  //     return 0;
  //   }
  // };

  // useEffect(()=>{
  //   fetchJoinedData()
  // },[])
  const handleStatusChange = (e) => {
    e.preventDefault();

    const willBeActive = !formData.isActive;

    if (willBeActive && newID) {
      axios
        .get(`getContestQuestionsByContestId/${newID}`)
        .then((res) => {
          const questions = res.data?.result.questions;
          if (
            !questions ||
            !Array.isArray(questions) ||
            questions.length === 0
          ) {
            setShowNoQuestionsWarning(true);
            return;
          }

          updateContestStatus(willBeActive);
        })
        .catch(() => {
          setShowNoQuestionsWarning(true);
        });
    } else {
      updateContestStatus(willBeActive);
    }
  };

  const updateContestStatus = (willBeActive) => {
    const newFormData = { ...formData, isActive: willBeActive, sendPushNotification };
    axios
      .put(`updateContest/${newID}`, newFormData)
      .then((res) => {
        if (res.data) {
          toast({
            title: `Success! Status has been updated`,
            status: "success",
            duration: 4000,
            isClosable: true,
            position: "top",
          });
          refetchData();
          onClose2();
        }
      })
      .catch((err) => {
        toast({
          title: err.response?.data?.message || `Something Went Wrong!`,
          status: "error",
          duration: 4000,
          isClosable: true,
          position: "top",
        });
      });
  };

  const finalData = useMemo(() => {
  let temp = [...data];

  // 🔍 SEARCH
  if (searchText) {
    temp = temp.filter((item) =>
      item.contestName?.toLowerCase().includes(searchText.toLowerCase())
    );
  }

  // 🎯 FILTER
  if (filterStatus === "active") {
    temp = temp.filter((item) => item.isActive === true);
  } else if (filterStatus === "inactive") {
    temp = temp.filter((item) => item.isActive === false);
  }

  // 🔃 SORT
  if (sortType === "price") {
    temp.sort((a, b) => b.entryCoin - a.entryCoin);
  }

  if (sortType === "date") {
    temp.sort(
      (a, b) => new Date(b.createdOn) - new Date(a.createdOn)
    );
  }

  return temp;
}, [data, searchText, sortType, filterStatus]);

useEffect(() => {
  setPage(1);
}, [searchText, sortType, filterStatus]);

// notification bell
const handleSendContestNotification = async (contestId) => {
  try {
    const res = await axios.post(
      `sendContestNotification/${contestId}`
    );

    toast({
      title: res.data.message,
      status: "success",
      duration: 3000,
      isClosable: true,
      position: "top",
    });
  } catch (error) {
    toast({
      title: "Failed to send notification",
      status: "error",
      duration: 3000,
      isClosable: true,
      position: "top",
    });
  }
};

const handleCancelContest = async (contestId) => {
  const confirm = window.confirm(
    "Are you sure you want to cancel this contest?\n\nAll joined users will be affected."
  );

  if (!confirm) return;

  try {
    const res = await axios.put(`cancelContest/${contestId}`);

    toast({
      title: res.data.message || "Contest cancelled successfully.",
      status: "success",
      duration: 4000,
      isClosable: true,
      position: "top",
    });

    refetchData();
  } catch (err) {
    toast({
      title: err.response?.data?.message || "Something went wrong.",
      status: "error",
      duration: 4000,
      isClosable: true,
      position: "top",
    });
  }
};

  const columns = React.useMemo(
    () => [
      {
        Header: "Sr No.",
        accessor: "srNo",
        Cell: ({ row: { index } }) => (
  <Cell text={(page - 1) * pageSize + index + 1} />
),
      },
      {
        Header: "Contest Name",
        accessor: "contestName",
        Cell: ({ value, row: { original } }) => (
          <>
            <Cell text={`${value}`} />
          </>
        ),
      },

      {
        Header: "Price",
        accessor: "entryCoin",
        Cell: ({ value, row: { original } }) => (
          <>
            <Cell text={` ${value}`} />
          </>
        ),
      },
      {
        Header: "thresholdEntryCoin",
        accessor: "thresholdEntryCoin",
        Cell: ({ value, row: { original } }) => (
          <>
            <Cell text={` ${original.thresholdEntryCoin}`} />
          </>
        ),
      },
      {
        Header: "Limit",
        accessor: "freeContestEarningThreshold",
        Cell: ({ value, row: { original } }) => (
          <>
            <Cell text={` ${original.freeContestEarningThreshold}`} />
          </>
        ),
      },
      {
        Header: " Prize Pool",
        accessor: "prizePoolCoin",
        Cell: ({ value, row: { original } }) => (
          <>
            <Cell text={` ${value}`} />
          </>
        ),
      },
      {
        Header: "1st Prize",
        accessor: "winnerPrizes",
        Cell: ({ value, row: { original } }) => (
          <>
            <Cell text={` ${value[0]}`} />
          </>
        ),
      },
      {
        Header: "Joined Slot",
        accessor: "",
        Cell: ({ value, row: { original } }) => {
          const [joinedSlots, setJoinedSlots] = useState(0);
          useEffect(() => {
            axios
              .get(`getTotalUserJoinedContestCount/${original._id}`)
              .then((res) => {
                if (res.data) {
                  setJoinedSlots(res?.data?.result?.totalUserJoinedCount);
                }
              })
              .catch((err) => {
                setJoinedSlots(0);
                // toast.error("Something went wrong. Please try again.");
              });
          }, [original._id]);

          return <Cell text={` ${joinedSlots}`} />;
        },
      },
      // {
      //   Header: "Total Slot",
      //   accessor: "totalSlot",
      //   Cell: ({ value, row: { original } }) => (
      //     <>
      //       <Cell text={` ${value}`} />
      //     </>
      //   ),
      // },
      {
        Header: "Total Questions",
        accessor: "",
        Cell: ({ value, row: { original } }) => {
          const [totalQuestions, setTotalQuestions] = useState(0);
          useEffect(() => {
            if (!original._id) return;
            axios
              .get(`getContestQuestionsByContestId/${original._id}`)
              .then((res) => {
                const count = res?.data?.result?.totalQuestions;
                if (typeof count === "number") {
                  setTotalQuestions(count);
                }
              })
              .catch((err) => {
                setTotalQuestions(0);
              });
          }, [original._id]);

          return <Cell text={` ${totalQuestions}`} />;
        },
      },
      {
        Header: "Status",
        accessor: "isActive",
        Cell: ({ value, row: { original } }) => (
          <>
            <Cell text={value ? "Active" : "In Active"} />
           <Cell
  text={
    original.isCancelled ? (
      <span className="text-red-600 font-semibold">Cancelled</span>
    ) : (
      "-"
    )
  }
/>
          </>
        ),
      },

      {
        Header: "Start On",
        accessor: "startTime",
        Cell: ({ value, row: { original } }) => (
          <Cell text={dayjs(value).format("D MMM, YYYY h:mm A")} />
        ),
      },

      {
        Header: "ViewResult",
        accessor: "",
        Cell: ({ value, row: { original } }) => {
          return (
            <>
              <Link
                to={`/dash/viewcontest-result/${original._id}`}
                state={{ returnToContestPage: page }}
              >
                <button
                  className="bg-purple p-2 rounded-xl text-white px-6 border-2 border-bgBlue"
                  //    onClick={()=>{ history.push({
                  //         pathname: "/d/create-question",
                  //         query: { ...history.query, userId: original._id },
                  //       });}}
                >
                  View Result
                </button>
              </Link>
            </>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row: { original } }) => {
          return (
            <>
              <Menu>
                <MenuButton
                  as={Button}
                  className="bg-bgBlue "
                  colorScheme="bgBlue"
                  onClick={() => setNewID(original._id)}
                >
                  Actions
                </MenuButton>
                <MenuList>
                  <Link to={`/dash/edit-contest/${original._id}`}>
                    <MenuItem>
                      {" "}
                      <MdEdit className="mr-4" /> Edit
                    </MenuItem>
                  </Link>

                  <MenuItem onClick={onOpen2}>
                    {" "}
                    <HiStatusOnline className="mr-4" /> Status
                  </MenuItem>

<MenuItem
  onClick={() => handleSendContestNotification(original._id)}
>
  🔔 Send Notification
</MenuItem>
                  <MenuItem onClick={onOpen}>
                    {" "}
                    <MdDelete className="mr-4" />
                    Delete
                  </MenuItem>
                  {!original.isCancelled && (
  <MenuItem
    color="red.500"
    onClick={() => handleCancelContest(original._id)}
  >
    ❌ Cancel Contest
  </MenuItem>
)}
                  <Link to={`/dash/viewcontest-question/${original._id}`}>
                    <MenuItem>
                      <GrOverview className="mr-4" /> View Question
                    </MenuItem>
                  </Link>
                  <Link to={`/dash/addcontest-question/${original._id}`}>
                    <MenuItem>
                      <GrOverview className="mr-4" /> Add Question
                    </MenuItem>
                  </Link>
                  <Link to={`/dash/join-user/${original._id}`}>
                    <MenuItem>
                      <GrOverview className="mr-4" /> View Join User
                    </MenuItem>
                  </Link>
                </MenuList>
              </Menu>
            </>
          );
        },
      },
      //   {
      //     Header: "Actions",
      //     accessor: "_id",
      //     Cell: ({ value, row: { original } }) => {
      //       return (
      //         <>
      //           <CustomMenu
      //             onChange={(opened) => setSelectedUserId(value)}
      //             target={<CustomButton size="sm">Actions</CustomButton>}
      //             items={[
      //               {
      //                 icon: <PencilLine />,
      //                 onClick: () => {
      //                   setActionsDialogs((val) => ({ ...val, edit: true }));

      //                 },
      //                 label: "Edit",
      //               },
      //               {
      //                 icon: <HandGrabbing />,
      //                 onClick: () => {
      //                   setActionsDialogs((val) => ({ ...val, hold: true }));
      //                 },
      //                 label: "Delete",
      //               },
      //               {
      //                 icon: <HandGrabbing />,
      //                 onClick: () => {
      //                   setActionsDialogs((val) => ({ ...val, status: true }));
      //                 },
      //                 label: "Status",
      //               },
      //               {
      //                 icon: <PencilLine />,
      //                 onClick: () => {
      //                   history.push({
      //                     pathname: "/d/question-view",
      //                     query: { ...history.query, userId: value },
      //                   });
      //                 },
      //                 label: "View Question",
      //               },

      //             ]}
      //           />
      //         </>
      //       );
      //     },
      //   },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data,page],
  );

  return (
    <div
      className="bg-bgWhite px-3 py-4 sm:px-4 lg:py-8"
      style={
        {
          // backgroundImage: `url('${bgImage}')`,
          // backgroundSize: "cover",
          //  backgroundRepeat: 'no-repeat',
          //  backgroundPosition: 'center'
        }
      }
    >
      <section className="md:p-1">
        <div>
          <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
            <div>
              <h2 className="text-xl font-bold text-purple text-oswald">
                View Contest
              </h2>
            </div>
            <div className="w-full lg:max-w-sm">
              <InputGroup borderRadius={5} size="sm">
                <InputLeftElement
                  pointerEvents="none"></InputLeftElement>
     <Input
  type="text"
  placeholder="Search..."
  border="1px solid #949494"
  value={searchText}
  onChange={(e) => {
    setPage(1);
    setSearchText(e.target.value);
  }}
/>
                <InputRightAddon p={0} border="none">
                  <Button
                    className="bg-purple"
                    colorScheme="#FF782D"
                    size="sm"
                    borderLeftRadius={0}
                    borderRightRadius={3.3}
                    border="1px solid #949494"
                  >
                    Search
                  </Button>
                </InputRightAddon>
              </InputGroup>
            </div>

            <div className="grid grid-cols-2 gap-2 sm:flex">
              <Menu>
                <MenuButton
                  as={Button}
                  colorScheme="#4D2C5E"
                  zIndex={20}
                  className="bg-bgBlue"
                >
                  Sort By
                </MenuButton>
                <MenuList zIndex={20}>
  <MenuItem onClick={() => setSortType("price")}>
    Sort by Price
  </MenuItem>

  <MenuItem onClick={() => setSortType("date")}>
    Sort by Date
  </MenuItem>

  <MenuItem onClick={() => setSortType("")}>
    Reset Sort
  </MenuItem>
</MenuList>
              </Menu>
              <Menu>
                <MenuButton
                  as={Button}
                  colorScheme="#FF782D"
                  zIndex={20}
                  className="bg-purple"
                  ref={btnRef}
                  onClick={onOpen3}
                >
                  Filter By
                </MenuButton>
              </Menu>
            </div>
            <Drawer
              isOpen={isOpen3}
              placement="right"
              onClose={onClose3}
              finalFocusRef={btnRef}
            >
              <DrawerOverlay />
              <DrawerContent>
                <DrawerCloseButton />
                <DrawerHeader>Filter Contests</DrawerHeader>

                <DrawerBody>
  <FormControl>
    <FormLabel>Status Filter</FormLabel>

    <Button
      size="sm"
      m={1}
      colorScheme={filterStatus === "active" ? "green" : "gray"}
      onClick={() => setFilterStatus("active")}
    >
      Active
    </Button>

    <Button
      size="sm"
      m={1}
      colorScheme={filterStatus === "inactive" ? "red" : "gray"}
      onClick={() => setFilterStatus("inactive")}
    >
      Inactive
    </Button>

    <Button
      size="sm"
      m={1}
      onClick={() => setFilterStatus("")}
    >
      Reset
    </Button>
  </FormControl>
</DrawerBody>

                <DrawerFooter>
                  <Button variant="outline" mr={3} onClick={onClose3}>
                    Cancel
                  </Button>
                  <Button colorScheme="blue">Save</Button>
                </DrawerFooter>
              </DrawerContent>
            </Drawer>
          </div>
          <div className="mt-5">
            <div className="hidden md:block">
              <Table data={finalData} columns={columns} />
            </div>

    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:hidden">
  {finalData.map((contest, index) => (
    <ContestCard
      key={contest._id}
      contest={contest}
      contestPage={page}
      serialNumber={(page - 1) * pageSize + index + 1}
      onChangeStatus={(contest) => {
        setNewID(contest._id);
        onOpen2();
      }}
      onSendNotification={(contest) => {
        handleSendContestNotification(contest._id);
      }}
      onCancelContest={(contestId) => {
        handleCancelContest(contestId);
      }}
    />
  ))}
</div>
<div className="mt-6 flex justify-center">
  <PaginationNav
    pageIndex={page}
    pageCount={totalPages}
    onPageChange={(newPage) => {
      if (newPage >= 1 && newPage <= totalPages) {
        setPage(newPage);
      }
    }}
  />
</div>
          </div>
      
        </div>
        <DeletePasswordModal
          isOpen={isOpen}
          onClose={onClose}
          onConfirm={handleDelete}
          title="Delete Contest"
          description="Password verify hone ke baad contest delete hoga."
        />
        {/* //Status Dialog// */}
        <AlertDialog
          isOpen={isOpen2}
          leastDestructiveRef={cancelRef}
          onClose={onClose2}
          isCentered
        >
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontSize="lg" fontWeight="bold">
                Change Contest Status
              </AlertDialogHeader>

              <AlertDialogBody>
                <Box
                  as="form"
                  id="edit-form"
                  px={4}
                  py={6}
                  w="full"
                  spacing={6}
                >
                  <FormControl id="status" w="full">
                    <FormLabel>Change Status?</FormLabel>
                    <Text mb={4}>
                      Current Status:{" "}
                      {formData.isActive ? "Active" : "Inactive"}
                    </Text>
                  </FormControl>
                  <FormControl display="flex" alignItems="center">
                    <Switch
                      isChecked={sendPushNotification}
                      onChange={(e) => setSendPushNotification(e.target.checked)}
                      colorScheme="purple"
                      mr={2}
                    />
                    <FormLabel mb={0}>
                      Send Push Notification to All Users
                    </FormLabel>
                  </FormControl>
                </Box>
              </AlertDialogBody>

              <AlertDialogFooter>
                <Button ref={cancelRef} onClick={onClose2}>
                  Cancel
                </Button>
                <Button colorScheme="red" onClick={handleStatusChange} ml={3}>
                  Change Status
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>

        <AlertDialog
          isOpen={showNoQuestionsWarning}
          leastDestructiveRef={cancelRef}
          onClose={() => setShowNoQuestionsWarning(false)}
          isCentered
        >
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontSize="lg" fontWeight="bold">
                Cannot Activate Contest
              </AlertDialogHeader>
              <AlertDialogBody>
                <Text color="red.600" fontWeight="semibold" mb={2}>
                  This contest has no questions and cannot be activated.
                </Text>
                <Text color="gray.600">
                  Please add at least one question to the contest before
                  activating it.
                </Text>
                <Link to={`/dash/addcontest-question/${newID}`}>
                  <Button colorScheme="purple" mt={4} w="full">
                    Add Questions Now
                  </Button>
                </Link>
              </AlertDialogBody>
              <AlertDialogFooter>
                <Button
                  ref={cancelRef}
                  onClick={() => setShowNoQuestionsWarning(false)}
                >
                  Close
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
      </section>
    </div>
  );
}

export default ViewContest;
